import { z } from 'zod';

export const AdminResetReportTypeSchema = z.enum(['customs', 'utb']);

const dateOnly = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);

export const AdminResetReportsByPeriodBodySchema = z.object({
  reportType: AdminResetReportTypeSchema,
  from: dateOnly,
  to: dateOnly,
});

export type AdminResetReportType = z.infer<typeof AdminResetReportTypeSchema>;
export type AdminResetReportsByPeriodBody = z.infer<typeof AdminResetReportsByPeriodBodySchema>;
